import React from 'react';

export type Props = {
  checked?: boolean;
  disabled?: boolean;
  onChange: (isChecked: boolean, value?: any | null | undefined) => void;
  id?: string;
  value?: string;
};

const Checkbox = ({
  onChange,
  value,
  checked = false,
  disabled = false,
  ...other
}: Props): JSX.Element => (
  <input
    {...other}
    checked={checked}
    disabled={disabled}
    type="checkbox"
    onChange={(e) => {
      if (typeof value !== 'undefined') {
        onChange(e.target.checked, value);
      } else {
        onChange(e.target.checked);
      }
    }}
  />
);

export default Checkbox;
